module.exports = __webpack_public_path__ + "static/media/CommerceCourt.6a949c1b.svg";